import { Controller } from '@hotwired/stimulus';

// Minimal stand-in for vault_controller on pages where the user cannot unlock
// anything yet (no personal vault, or no organization access). Data pages call
// window.vault.is_open() / openModal() / decryptMessage() unconditionally; this
// stub answers them by prompting vault setup instead of leaving window.vault
// undefined (TypeError).
export default class extends Controller {
  static targets = ['dialog'];

  connect() {
    window.vault = this;
  }

  disconnect() {
    if (window.vault === this) window.vault = undefined;
  }

  is_open() {
    return false;
  }

  openModal(_callback) {
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  async decryptMessage(_message) {
    throw 'Vault not open';
  }
}
